export const locale = {
  lang: 'fr-CA',
  data: {
    UPGRADE_PANEL: {
      PRO_BADGE: 'PRO',
      ORDER: 'Commander',
      LEARN_MORE: 'En savoir plus',
      CLOSE: 'Fermer',
      COMING_SOON: 'à venir',
      HOW_IT_WORKS: 'Comment ça marche',
      FEATURES: {
        TITLE: 'Fonctionnalités',
        TAGLINE:
          'Tout ce que le forfait PRO ajoute à votre Gestion-Traiteur, au même endroit.',
        INTRO:
          'Le forfait PRO regroupe les modules qui font gagner du temps à votre équipe et des clients à votre entreprise : Soumission Web, Automatisations, Intégrations, un tableau de bord Performance enrichi et, bientôt, un CRM.',
        BENEFITS: {
          SUBMISSIONS: {
            TITLE: 'Soumission Web',
            TEXT: 'Vos clients demandent une soumission depuis votre boutique en ligne, 24 heures sur 24 ; la demande arrive complète dans Gestion-Traiteur et devient une proposition ou une commande en un clic.',
          },
          AUTOMATIONS: {
            TITLE: 'Automatisations',
            TEXT: 'Vos rapports générés et livrés automatiquement, par courriel, dans Google Drive ou Microsoft OneDrive, à la fréquence que vous fixez, et une API externe pour connecter vos propres outils.',
          },
          INTEGRATIONS: {
            TITLE: 'Intégrations',
            TEXT: 'Zapier, QuickBooks Online, Google Drive et Google Agenda, Microsoft OneDrive et Outlook Agenda : vos applications parlent à Gestion-Traiteur, sans double saisie.',
          },
          KPI: {
            TITLE: 'Tableau de bord Performance, version PRO',
            TEXT: 'Des indicateurs plus fins : ventes et taux de conversion par conseiller, par type d’événement et par période, comparaisons d’une année à l’autre. Pilotez vos ventes avec précision, pas au feeling.',
          },
          CRM: {
            TITLE: 'Module CRM (à venir)',
            TEXT: 'Suivez vos prospects, vos relances et vos occasions d’affaires directement dans Gestion-Traiteur, reliés à vos clients et à vos événements.',
          },
        },
        STEPS: {
          S1: 'Explorez chaque module de ce menu : Soumission Web, Automatisations, Intégrations.',
          S2: 'Cliquez « Commander » et dites-nous ce qui vous intéresse.',
          S3: 'Notre équipe active le forfait PRO et vous accompagne dans la mise en place.',
        },
        PUNCH:
          'Un seul forfait, tous les outils : passez au PRO et laissez votre équipe se concentrer sur vos clients.',
      },
      SUBMISSIONS: {
        TITLE: 'Soumission Web',
        TAGLINE:
          'Transformez chaque visiteur de votre boutique en demande de soumission, et chaque demande en événement, en un clic.',
        INTRO:
          'Vos clients demandent une soumission directement depuis votre boutique en ligne, 24 heures sur 24. Fini les courriels perdus et les retranscriptions : la demande arrive complète dans Gestion-Traiteur, prête à devenir une proposition ou une commande.',
        BENEFITS: {
          FORM: {
            TITLE: 'Un formulaire professionnel, sur votre boutique',
            TEXT: 'Coordonnées, type de service (traiteur, boîte à lunch, cocktail, buffet…), date, nombre de convives et message : tout ce qu’il faut pour chiffrer sans rappeler le client.',
          },
          NO_RETYPING: {
            TITLE: 'Zéro ressaisie',
            TEXT: 'Chaque demande apparaît dans la section Soumissions Web, avec une puce « à traiter » dans votre menu. Un client existant est reconnu par son courriel ; sinon, sa fiche se crée d’un clic.',
          },
          ONE_CLICK: {
            TITLE: 'De la demande à l’événement en un clic',
            TEXT: 'Convertissez en proposition ou en commande : l’événement, le client, la date, l’heure, les convives et la note générale sont pré-remplis avec le contenu du formulaire.',
          },
          INSTANT_REPLY: {
            TITLE: 'Une réponse instantanée, à votre image',
            TEXT: 'Le visiteur reçoit aussitôt un courriel de remerciement personnalisable (Configuration → Messages), et votre équipe est avisée sur-le-champ.',
          },
          NOTHING_LOST: {
            TITLE: 'Rien ne se perd',
            TEXT: 'Archivez, retrouvez et rouvrez les demandes ; chaque conversion est tracée dans l’historique du client et de l’événement.',
          },
        },
        STEPS: {
          S1: 'Le visiteur remplit le formulaire « Soumission » de votre boutique en ligne.',
          S2: 'Vous recevez la demande dans Gestion-Traiteur : puce dans le menu et courriel à votre équipe.',
          S3: 'Vous la convertissez en proposition ou en commande. Le client a déjà reçu votre remerciement.',
        },
        PUNCH:
          'Répondez plus vite que vos concurrents : la première soumission reçue est souvent celle qui est retenue.',
      },
      AUTOMATIONS: {
        TITLE: 'Automatisations',
        TAGLINE:
          'Laissez Gestion-Traiteur travailler pendant que vous dormez : les bons rapports, aux bonnes personnes, au bon moment.',
        INTRO:
          'Planifiez une fois, recevez toujours. Le module Automatisations génère vos rapports et les livre, par courriel, dans Google Drive ou dans Microsoft OneDrive, selon l’horaire que vous fixez, et ouvre vos données à vos propres outils grâce à l’API externe.',
        BENEFITS: {
          SCHEDULED_REPORTS: {
            TITLE: 'Vos rapports, livrés sans y penser',
            TEXT: 'Liste des événements du jour, feuille de production, livraisons… Choisissez le rapport, la fréquence (quotidienne, hebdomadaire, mensuelle) et l’heure : il part à l’heure dite, dans votre fuseau horaire, même les jours fériés.',
          },
          RIGHT_PERIOD: {
            TITLE: 'La bonne période, recalculée à chaque envoi',
            TEXT: 'Aujourd’hui, demain ou les N prochains jours : la fenêtre de dates se recalcule à chaque exécution. Le rapport du lundi matin couvre toujours la bonne semaine.',
          },
          EMAIL_OR_DRIVE: {
            TITLE:
              'Par courriel, ou directement dans Google Drive ou Microsoft OneDrive',
            TEXT: 'PDF ou Excel en pièce jointe aux destinataires de votre choix (à, cc, cci), ou classé automatiquement dans Google Drive ou Microsoft OneDrive, par rapport et par mois. Dans Google Drive, un Excel devient une feuille Google Sheets prête à filtrer.',
          },
          EXTERNAL_API: {
            TITLE: 'Une API externe pour vos propres outils',
            TEXT: 'Connectez votre site web, votre ERP ou vos tableaux de bord aux données de Gestion-Traiteur avec des accès sécurisés, limités à ce que vous autorisez, et des rapports PDF générés à la demande.',
          },
          IN_CONTROL: {
            TITLE: 'Toujours sous contrôle',
            TEXT: '« Exécuter maintenant » pour valider un envoi, statut et détail de la dernière exécution visibles en un coup d’œil, activation ou pause en un clic.',
          },
          WEBHOOKS_MCP: {
            TITLE: 'Webhooks et MCP (à venir)',
            TEXT: 'Poussez un événement vers vos outils dès qu’il se produit et connectez Gestion-Traiteur à votre assistant IA.',
          },
        },
        STEPS: {
          S1: 'Choisissez le rapport, la fréquence et l’heure d’envoi.',
          S2: 'Indiquez la période couverte et la destination : destinataires courriel, dossier Google Drive ou Microsoft OneDrive.',
          S3: 'Gestion-Traiteur génère et livre le rapport à chaque échéance ; vous suivez le statut dans Configuration → Automatisation.',
        },
        PUNCH:
          'Chaque matin, votre cuisine, vos livreurs et vos gestionnaires ont déjà leur rapport en main, sans que personne n’ait cliqué.',
      },
      INTEGRATIONS: {
        TITLE: 'Intégrations',
        TAGLINE:
          'Vos outils préférés, enfin connectés à votre traiteur : plus de double saisie, plus de copier-coller.',
        INTRO:
          'Comptabilité, agendas, fichiers, automatisation : Gestion-Traiteur parle aux applications que votre équipe utilise déjà. Les données circulent toutes seules et restent à jour, sans effort de votre part.',
        BENEFITS: {
          ZAPIER: {
            TITLE: 'Zapier : plus de 10 000 applications à portée de Zap',
            TEXT: 'Dès qu’un client, un événement ou une facture est créé dans Gestion-Traiteur, déclenchez vos automatisations dans Slack, Google Sheets, votre CRM, votre outil de courriel… sans une ligne de code. * Un développement sur mesure pourrait être nécessaire.',
          },
          QBO: {
            TITLE:
              'QuickBooks Online : votre comptabilité à jour, sans ressaisie',
            TEXT: 'Envoyez vos clients, vos factures et vos encaissements vers QuickBooks Online directement depuis Gestion-Traiteur. Votre comptable travaille sur des chiffres exacts, vous gagnez des heures chaque mois.',
          },
          GOOGLE: {
            TITLE: 'Google Drive et Google Agenda',
            TEXT: 'Vos rapports se classent tout seuls dans Google Drive, dans le dossier de votre choix. Vos événements, livraisons, affectations du personnel, salles et anniversaires apparaissent dans des agendas Google partageables avec toute l’équipe, sur tous ses appareils.',
          },
          MICROSOFT: {
            TITLE: 'Microsoft OneDrive et Outlook Agenda',
            TEXT: 'La même chose pour l’univers Microsoft : rapports envoyés vers OneDrive, calendriers synchronisés dans Outlook. Connexion avec votre compte Microsoft, sans mot de passe supplémentaire.',
          },
          SECURE: {
            TITLE: 'Une connexion par organisation, sécurisée et révocable',
            TEXT: 'Chaque intégration s’autorise avec le compte officiel (OAuth) de votre entreprise : aucun mot de passe stocké, des accès limités au strict nécessaire, et une déconnexion en un clic depuis Configuration → Intégrations.',
          },
          SOON: {
            TITLE: 'Bientôt : Mailchimp et Webex',
            TEXT: 'Alimentez vos campagnes Mailchimp avec vos listes de clients, et voyez la fiche du client s’ouvrir dès qu’il vous appelle avec Webex.',
          },
        },
        STEPS: {
          S1: 'Dans Configuration → Intégrations, connectez votre compte Google, Microsoft, QuickBooks ou Zapier en quelques clics.',
          S2: 'Choisissez ce qui circule : rapports, agendas, clients, factures, événements.',
          S3: 'Gestion-Traiteur synchronise en continu ; vous gardez le contrôle et pouvez déconnecter à tout moment.',
        },
        PUNCH:
          'Chaque intégration vous fait gagner des heures par semaine : connectez-en une aujourd’hui, et laissez le reste suivre.',
      },
      AI: {
        TITLE: 'IA',
        INTRO:
          "L'intelligence artificielle au service de votre traiteur. À venir.",
      },
    },
  },
};
